import { AttributedText, TextLine } from '@euler/model/AttributedText';
import { memo } from 'react';
import { Text, TextProps } from 'react-native';
import { useTheme } from 'styled-components';

export function isArray<T>(array: T | T[]): array is T[] {
  return Array.isArray(array);
}

const TextSegment = memo(
  ({ segment }: { segment: string | AttributedText }) => {
    const theme = useTheme();
    return (
      <Text
        style={
          typeof segment === 'string'
            ? undefined
            : {
                fontFamily: segment.fontFamily,
                fontSize: segment.fontSize,
                color:
                  typeof segment.color === 'string'
                    ? segment.color
                    : segment.color?.(theme),
              }
        }
      >
        {typeof segment === 'string' ? segment : segment.text}
      </Text>
    );
  },
);

export const Tagline = memo(
  ({ tagline, ...props }: { tagline: TextLine } & TextProps) => {
    return (
      <Text {...props}>
        {typeof tagline === 'string' ? (
          tagline
        ) : isArray(tagline) ? (
          tagline.map((segment, k) => <TextSegment key={k} segment={segment} />)
        ) : (
          <TextSegment segment={tagline} />
        )}
      </Text>
    );
  },
);
